import { logUserAction } from '@office-start/telemetry-service';
const converDialogTypeToSubArea = (dialog) => {
    switch (dialog) {
        case 'ABOUT':
            return 'MOSAboutDialog';
        case 'INSTALL':
            return 'MOSInstallDialog';
        case 'UPGRADE':
            return 'MOSUpgradeDialog';
        case 'ADAPTIVECARD':
            return 'MOSAdaptiveCardDialog';
        case 'TASKMODULE':
        default:
            return 'MOSTaskModuleDialog';
    }
};
export const logTaskModuleUserAction = (type, id, result, dialogType, appId) => {
    logUserAction({
        type,
        id,
        area: 'MOSTaskModuleDialog',
        result,
        target: 'MOSTaskModuleDialog',
        eventName: "MOS_Task_Module_Dialog" /* KnownFeatureInstrumentationEvents.MOSTaskModuleDialog */,
        subArea: converDialogTypeToSubArea(dialogType),
        targetId: appId,
    });
};
//# sourceMappingURL=logTaskModuleUserAction.js.map